import {
  authApi,
  saleApi,
  supplierApi,
  invoiceApi,
  expenseApi,
  employeApi,
  paycostApi,
  recipeApi,
  recipeProductApi,
  recipeCategoryApi,
  recipeProductCategoryApi,
  inventoryApi,
  taxeApi,
  localisationApi,
  inventoryTemplateApi,
  wasteCauseApi,
  preparationSlipApi,
  preparationSlipTemplateApi,
  debugApi,
  orderTemplateApi,
  deliverySlipApi,
  customerAccountApi,
  storeApi,
  tagApi,
  customUnitApi,
  integratedTransactionApi,
  autoPreparationSlipApi,
  scheduledPreparationApi,
  tillApi,
  analyticApi,
  globalSupplierApi,
  bucketApi,
  expirationApi
} from "./module";

const publicApi = { ...authApi };
const privateApi = {
  ...saleApi,
  ...supplierApi,
  ...invoiceApi,
  ...expenseApi,
  ...employeApi,
  ...paycostApi,
  ...recipeApi,
  ...recipeProductApi,
  ...recipeCategoryApi,
  ...recipeProductCategoryApi,
  ...inventoryApi,
  ...taxeApi,
  ...localisationApi,
  ...inventoryTemplateApi,
  ...wasteCauseApi,
  ...preparationSlipApi,
  ...preparationSlipTemplateApi,
  ...debugApi,
  ...orderTemplateApi,
  ...deliverySlipApi,
  ...customerAccountApi,
  ...storeApi,
  ...tagApi,
  ...customUnitApi,
  ...integratedTransactionApi,
  ...autoPreparationSlipApi,
  ...scheduledPreparationApi,
  ...tillApi,
  ...analyticApi,
  ...globalSupplierApi,
  ...bucketApi,
  ...expirationApi
};

const api = {
  ...publicApi,
  ...privateApi
};

export { api, publicApi, privateApi };
